import { useEffect, useRef } from "react"
import { useFormikContext } from "formik"
import { DynamicAccountingKey, MeetingServiceTabValues } from "../../form/formTypes"
import { DimensionGuard } from "./DimensionGuard"
import { collectValidEntries } from "./helpers"

export type FieldEntry = Readonly<{
    key: DynamicAccountingKey
    value: { dimensionId: number; value: string }
    dimensionIdFromConfig: number
}>

type DimensionsGuardManagerProps = Readonly<{
    userId: number
}>

export function DimensionsGuardManager({ userId }: DimensionsGuardManagerProps) {
    const { values, setFieldValue } = useFormikContext<MeetingServiceTabValues>()

    const frozenRef = useRef<FieldEntry[] | undefined>(undefined)

    useEffect(() => {
        if (frozenRef.current !== undefined) return

        const entries = collectValidEntries(values)
        if (entries.length > 0) {
            frozenRef.current = entries
        }
    }, [values])

    const frozen = frozenRef.current ?? []

    return (
        <>
            {frozen.map(({ key, value, dimensionIdFromConfig }) => (
                <DimensionGuard
                    key={key}
                    userId={userId}
                    fieldKey={key}
                    value={value}
                    setFieldValue={setFieldValue}
                    dimensionIdFromConfig={dimensionIdFromConfig}
                />
            ))}
        </>
    )
}
